import { createFileRoute } from '@tanstack/react-router';
import { BreakGlassPage } from '@/features/break-glass';

export const Route = createFileRoute('/_auth/break-glass')({
  component: BreakGlassPage,
});
